import Component from '@ember/component';
import { action, computed, get } from '@ember/object';
import { next } from '@ember/runloop';

/*
  attrs
  - changeset
  - property
  - label
  - labelAbove
    - if true, places the label above the checkbox
    - default is false
  - showValidationErrors
  - onChange(newVal)
*/
export default Component.extend({
  classNames: ['form-check'],
  classNameBindings: ['hasErrors'],
  label: null,
  labelAbove: false,
  changeset: null,
  // the associated property on the changeset
  property: null,
  showValidationErrors: false,
  hasErrors: computed(
    'showValidationErrors',
    'changeset.errors.[]',
    'property',
    function () {
      if (this.showValidationErrors === false) {
        return false;
      }

      let property = this.property;
      return (
        get(this, 'changeset.errors').find(function (item) {
          return get(item, 'key') === property;
        }) != null
      );
    },
  ),

  handleChange: action(function (event) {
    const target = event.target;
    this.changeset.set(this.property, target.checked);
    this.onChange?.(this.changeset.get(this.property));
  }),
});
